/**
 * CardGrid — DS Layout
 * Grille de cartes auto-fill responsive (masonry-like, CSS Grid auto-fill)
 */

import styles from './CardGrid.module.css';

interface CardGridProps {
  children: React.ReactNode;
  minCardWidth?: string;
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function CardGrid({ children, minCardWidth = '280px', gap = 'md', className = '' }: CardGridProps) {
  return (
    <div
      className={`${styles.grid} ${styles[`gap${gap}`]} ${className}`}
      style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${minCardWidth}, 1fr))` }}
    >
      {children}
    </div>
  );
}
